export const ingredientCategories = [
  {
    eyebrow: "Fruits",
    title: "Fruits that travel well.",
    description:
      "Freeze-dried mango, pineapple, banana, berries and tropical fruit ingredients designed for global applications across snacks, cereals, smoothies and wellness products.",
    image: "/images/category-freeze-dried-fruits.jpg",
    formats: "Slices, dices, granules, powders",
    applications: "Snacks, cereal inclusions, smoothie blends"
  },
  {
    eyebrow: "Vegetables",
    title: "Vegetables with longer possibilities.",
    description:
      "Corn, peas, mushroom, beetroot, bell peppers and vegetable ingredients designed for modern food applications and shelf-stable innovation.",
    image: "/images/category-freeze-dried-vegetables.jpg",
    formats: "Dices, flakes, powders, custom cuts",
    applications: "Ready meals, soups, savory blends"
  },
  {
    eyebrow: "Herbs & Botanicals",
    title: "Botanicals with shelf life.",
    description:
      "Tulsi, mint, ginger, rosemary, lemongrass and wellness-focused ingredients for tea, nutraceutical and functional food ecosystems.",
    image: "/images/premium-herbal-tea.jpg",
    formats: "Leaves, flakes, cuts, powders",
    applications: "Tea blends, wellness products, nutraceuticals"
  },
  {
    eyebrow: "Tea Cuts",
    title: "Tea cuts for modern blends.",
    description:
      "Freeze-dried ginger tea cut, lemon tea cut, orange peel, mint flakes and botanical inclusions crafted for premium tea and wellness applications.",
    image: "/images/category-tea-cuts.jpg",
    formats: "Cuts, flakes, inclusions",
    applications: "Tea, infusions, wellness beverage blends"
  },
  {
    eyebrow: "Functional Ingredients",
    title: "Ingredients built for evolving food brands.",
    description:
      "Powders, blends and ingredient formats designed for nutraceuticals, wellness products, smoothies and functional food formulations.",
    image: "/images/ingredient-fruit-powder.jpg",
    formats: "Powders, blends, private-label formats",
    applications: "Functional foods, supplements, beverages"
  }
];

export const whyFreezeDrying = [
  {
    title: "Better nutrient retention.",
    text: "Designed to preserve flavor, aroma and functionality with minimal compromise."
  },
  {
    title: "Built for modern formulations.",
    text: "Used across nutraceuticals, wellness products, beverages and functional foods."
  },
  {
    title: "Lightweight. Export-friendly.",
    text: "Lower moisture, longer shelf life and reduced dependency on refrigeration."
  },
  {
    title: "Clean-label possibilities.",
    text: "Helping brands explore ingredient formats with fewer compromises."
  }
];

export const capabilityCards = [
  {
    title: "Application-led sourcing",
    text: "Ingredient formats are mapped to the finished product use case before sourcing conversations begin."
  },
  {
    title: "Format flexibility",
    text: "Cuts, flakes, dices, granules and powders can be evaluated around texture, solubility and visual inclusion needs."
  },
  {
    title: "Export-aware planning",
    text: "Moisture, shelf life, labeling, documentation and repeat supply are treated as part of the commercial brief."
  }
];

export const industries = [
  "Food & Beverage Brands",
  "Tea & Wellness Brands",
  "Nutraceutical Companies",
  "Ingredient Importers",
  "HoReCa & Industrial Food",
  "Functional Food Brands",
  "Private Label Businesses"
];

export const targetAudiences = [
  "International importers",
  "Ingredient distributors",
  "Nutraceutical companies",
  "Tea & wellness brands",
  "Functional food companies",
  "Private-label businesses"
];

export const applicationBlocks = [
  {
    title: "Tea & Wellness",
    text: "Tea cuts, herbs, botanicals and wellness-focused ingredients."
  },
  {
    title: "Nutraceuticals",
    text: "Functional powders and ingredient applications."
  },
  {
    title: "Functional Foods",
    text: "Ingredients for modern formulations and wellness products."
  },
  {
    title: "HoReCa",
    text: "Shelf-stable premium ingredient solutions."
  },
  {
    title: "Healthy Snacks",
    text: "Freeze-dried fruit and vegetable applications."
  }
];

export const sourcingSteps = [
  {
    step: "01",
    title: "Brief the application",
    text: "Product type, target market, ingredient role, format, pack size and commercial expectations."
  },
  {
    step: "02",
    title: "Map ingredient fit",
    text: "Availability, seasonality, processing fit, sensory profile, color, texture and export practicality."
  },
  {
    step: "03",
    title: "Confirm format route",
    text: "Slices, dices, cuts, granules, powder or custom formats aligned to use case and MOQ realities."
  },
  {
    step: "04",
    title: "Build continuity",
    text: "Repeat ordering, documentation, supplier communication and long-term sourcing clarity."
  }
];

export const buyerSignals = [
  "B2B ingredient focus",
  "India-origin sourcing",
  "Private-label friendly",
  "Food, beverage and wellness applications",
  "Export documentation planning",
  "Catalog and custom inquiry routes"
];
